/**
 * Normalizes and validates website URLs for Maxmark forms
 */
export const normalizeUrl = (url) => {
  if (!url || url.trim() === '') return null;
  let trimmed = url.trim();
  
  // Basic validation pattern for a domain
  const pattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
  if (!pattern.test(trimmed)) {
    return 'invalid'; 
  }

  // Prepend https if missing
  if (!/^https?:\/\//i.test(trimmed)) {
    trimmed = `https://${trimmed}`;
  }
  
  return trimmed;
};